import React from "react";
import Squirrels from "../components/squirrels";
import Beavers from "../components/beavers";
import Cubs from "../components/cubs";
import Scouts from "../components/scouts";

function Section(props) {
  const section = props.section;

  switch (section) {
    case "squirrels":
      return <Squirrels />;
    case "beavers":
      return <Beavers />;
    case "cubs":
      return <Cubs />;
    case "scouts":
      return <Scouts />;
    default:
      return null;
  }
}

export default Section;
